import { render, staticRenderFns } from "./DetailSheet.vue?vue&type=template&id=bab0a5bc&scoped=true&"
import script from "./DetailSheet.vue?vue&type=script&lang=js&"
export * from "./DetailSheet.vue?vue&type=script&lang=js&"
import style0 from "./DetailSheet.vue?vue&type=style&index=0&id=bab0a5bc&lang=less&scoped=true&"
import style1 from "./DetailSheet.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab0a5bc",
  null
  
)

export default component.exports